// extracted by mini-css-extract-plugin
export default {"container":"kW-z","title":"lW-z","link":"mW-z"};